export default {
  props: {
    itemCount: { type: Number, required: true },
    value: { type: Number, required: true },
    autoAdvance: { type: Boolean, default: true },
  },
  data() {
    return {
      dragging: false,
    };
  },
  computed: {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  methods: {
    handleButtonClick(direction) {
      this.$emit('buttonClick', { direction });
    },
  },
};
